import * as React from 'react';
import { DestinationRefinementCarousel } from './destination-refinement-carousel';
import { DestinationRefinementList } from './destination-refinement-list';
import { PwaHsrPropertyDestinationRefinement } from 'src/common/__generated__/api';
import { AnalyticsStore } from 'bernie-core';

export interface DestinationRefinementContainerProps {
  isCarousel: boolean;
  showAffinities?: boolean;
  showDescription?: boolean;
  title: string;
  destinations: PwaHsrPropertyDestinationRefinement.Destinations[];
  analytics?: AnalyticsStore;
}

export const DestinationRefinementContainer: React.FunctionComponent<DestinationRefinementContainerProps> = ({
  isCarousel,
  showAffinities,
  showDescription,
  title,
  destinations,
  analytics
}) => {
  React.useEffect(() => {
    logImpression(destinations, analytics);
  }, []);

  return isCarousel ? (
    <DestinationRefinementCarousel {...{ title, showAffinities, showDescription, destinations, analytics }} />
  ) : (
    <DestinationRefinementList {...{ title, showAffinities, showDescription, destinations }} />
  );
};

const MIN_DESTINATIONS: number = 2;
const showDestRefinement = (destinations: PwaHsrPropertyDestinationRefinement.Destinations[]): boolean =>
  destinations && destinations.length >= MIN_DESTINATIONS;

const logImpression = (destinations: PwaHsrPropertyDestinationRefinement.Destinations[], analytics: AnalyticsStore): void => {
  if (showDestRefinement(destinations)) {
    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent('.DestinationRefinement.Imp', 'Showing dest refinement module', analytics.omnitureData);
    }
  }
};
